const PRODUCT_FAMILY = Object.freeze({
  ASO: 'ASO',
  MARKET: 'MARKET',
  AD_INTEL: 'AD_INTEL',
  CPP: 'CPP',
  CREATIVE: 'CREATIVE',
  SA_INTEL: 'SA_INTEL',
  SSO: 'SSO',
  COMPASS: 'COMPASS',
  API: 'API', // for plans page. It is not a product family
  ASO_SERVICES: 'ASO_SERVICES', // for plans page. It is not a product family
  SEARCH_ADS: 'SEARCH_ADS',
})

const PRODUCTS = Object.freeze({
  ADMIN_PRODUCT: 'ADMIN_PRODUCT',
  MA_FREEMIUM: 'MA_FREEMIUM',
  SA_FREEMIUM: 'SA_FREEMIUM',
  ASA_FREEMIUM: 'ASA_FREEMIUM',
  ASO_LITE: 'ASO_LITE',
  ASO_BASIC: 'ASO_BASIC',
  ASO_BASIC_V2: 'ASO_BASIC_V2',
  ASO_PRO: 'ASO_PRO',
  ASO_GROWTH: 'ASO_GROWTH',
  ASO_BUSINESS: 'ASO_BUSINESS',
  MARKET_ENTERPRISE: 'MARKET_ENTERPRISE',
  MARKET_PRO: 'MARKET_PRO',
  COMPASS: 'COMPASS',
  SEARCH_ADS: 'SEARCH_ADS',
  AD_INTEL_ENTERPRISE: 'AD_INTEL_ENTERPRISE',
  CPP_INTEL_ENTERPRISE: 'CPP_INTEL_ENTERPRISE',
  SA_INTEL_ENTERPRISE: 'SA_INTEL_ENTERPRISE',
})

const FEATURES = Object.freeze({
  ACCESS_ADMIN_DASHBOARD: 'ACCESS_ADMIN_DASHBOARD',
  ADMIN_IMPERSONATE: 'ADMIN_IMPERSONATE',
  ADMIN_ACCESS_DEV: 'ADMIN_ACCESS_DEV',
  ADMIN_ACCESS_SA_REPORT: 'ADMIN_ACCESS_SA_REPORT',
  SEARCHADS_SMART_ADMIN: 'SEARCHADS_SMART_ADMIN',
  SSO_LOGIN: 'SSO_LOGIN',

  // API
  ACCESS_DATA_API: 'ACCESS_DATA_API',

  // APP INTEL
  ACCESS_COMPASS_EXPLORE: 'ACCESS_COMPASS_EXPLORE',
  ACCESS_COMPASS_TRACE: 'ACCESS_COMPASS_TRACE',
  ACCESS_COMPASS_IMPACT: 'ACCESS_COMPASS_IMPACT',
  ACCESS_APP_PROFILE: 'ACCESS_APP_PROFILE',
  ACCESS_PUBLISHER_PROFILE: 'ACCESS_PUBLISHER_PROFILE',
  ACCESS_FEATURED_APPS: 'ACCESS_FEATURED_APPS',
  ACCESS_CATEGORY_RANKINGS: 'ACCESS_CATEGORY_RANKINGS',
  ACCESS_REVIEW_ANALYSIS: 'ACCESS_REVIEW_ANALYSIS',
  ACCESS_SENTIMENT_ANALYSIS: 'ACCESS_SENTIMENT_ANALYSIS', // for reviews page most mentioned keywords tab
  ACCESS_RATING: 'ACCESS_RATING',
  ACCESS_SIMILAR_APPS: 'ACCESS_SIMILAR_APPS',
  ACCESS_SALES_METRICS: 'ACCESS_SALES_METRICS',
  ACCESS_IN_APP_EVENTS: 'ACCESS_IN_APP_EVENTS',
  ACCESS_PROMOTIONAL_CONTENT: 'ACCESS_PROMOTIONAL_CONTENT',
  ACCESS_TOP_CHARTS: 'ACCESS_TOP_CHARTS',
  ACCESS_APP_UPDATE_PINS: 'ACCESS_APP_UPDATE_PINS',

  // ASO INTEL
  ACCESS_ASO_OVERVIEW: 'ACCESS_ASO_OVERVIEW',
  ACCESS_STORE_MANAGEMENT: 'ACCESS_STORE_MANAGEMENT',
  ACCESS_KEYWORD_TRACKING: 'ACCESS_KEYWORD_TRACKING',
  ACCESS_KEYWORD_INSPECTOR: 'ACCESS_KEYWORD_INSPECTOR',
  ACCESS_PERFORMANCE_COMPARISON: 'ACCESS_PERFORMANCE_COMPARISON', // for keyword inspector page
  ACCESS_KEYWORD_TRANSLATOR: 'ACCESS_KEYWORD_TRANSLATOR',
  ACCESS_ORGANIC_VISIBILITY_HISTORY: 'ACCESS_ORGANIC_VISIBILITY_HISTORY',
  ACCESS_ALL_RANKED_KEYWORDS: 'ACCESS_ALL_RANKED_KEYWORDS', // for aso report page
  COMPARE_DATES: 'COMPARE_DATES', // for aso report page
  ACCESS_MULTI_COMPARISON: 'ACCESS_MULTI_COMPARISON', // for competitor keywords page
  ACCESS_IOS_DOWNLOAD_REPORT: 'ACCESS_IOS_DOWNLOAD_REPORT',

  /** @deprecated use 'ACCESS_METADATA_OPTIMIZATION' */
  ACCESS_KEYWORD_OPTIMIZATION: 'ACCESS_KEYWORD_OPTIMIZATION',
  ACCESS_METADATA_OPTIMIZATION: 'ACCESS_METADATA_OPTIMIZATION',

  ACCESS_ASO_REPORT: 'ACCESS_ASO_REPORT',
  ACCESS_KEYWORD_TRENDS: 'ACCESS_KEYWORD_TRENDS',
  ACCESS_VISIBILITY_REPORT: 'ACCESS_VISIBILITY_REPORT',
  ACCESS_iOS_DOWNLOAD_REPORT: 'ACCESS_iOS_DOWNLOAD_REPORT',

  /** @deprecated - use 'ACCESS_DOWNLOAD_SHARE' */
  ACCESS_KEYWORD_INTELLIGENCE: 'ACCESS_KEYWORD_INTELLIGENCE',
  ACCESS_DOWNLOAD_SHARE: 'ACCESS_DOWNLOAD_SHARE',

  ACCESS_APP_UPDATE_TIMELINE: 'ACCESS_APP_UPDATE_TIMELINE',
  ACCESS_LOCALIZATION: 'ACCESS_LOCALIZATION',

  /** @deprecated - use 'ACCESS_COMPETITOR_KEYWORDS' */
  ACCESS_KEYWORD_GAP: 'ACCESS_KEYWORD_GAP',
  ACCESS_COMPETITOR_KEYWORDS: 'ACCESS_COMPETITOR_KEYWORDS',

  // SEARCH ADS INTEL
  ACCESS_SEARCHADS_INTELLIGENCE: 'ACCESS_SEARCHADS_INTELLIGENCE',
  ACCESS_CPP_INTELLIGENCE: 'ACCESS_CPP_INTELLIGENCE',

  // MARKET INTEL
  ACCESS_MARKET_INTELLIGENCE: 'ACCESS_MARKET_INTELLIGENCE',

  // AD INTEL
  ACCESS_AD_INTELLIGENCE: 'ACCESS_AD_INTELLIGENCE',

  // QUOTA
  ADD_TEAM_MEMBER: 'ADD_TEAM_MEMBER',
  ACCESS_HISTORICAL_DATA: 'ACCESS_HISTORICAL_DATA',
  TRACK_APP: 'TRACK_APP',
  TRACK_KEYWORD: 'TRACK_KEYWORD',
  TRACK_COMPETITOR: 'TRACK_COMPETITOR',

  EXPORT_CSV: 'EXPORT_CSV',
  REPLY_TO_REVIEW: 'REPLY_TO_REVIEW',
  ADD_CUSTOM_ALERT: 'ADD_CUSTOM_ALERT',
  CAN_CANCEL_SUBSCRIPTION: 'CAN_CANCEL_SUBSCRIPTION',
  CAN_REMOVE_CARD: 'CAN_REMOVE_CARD',
  EXPLORE_COMPARE_APPS: 'EXPLORE_COMPARE_APPS',
  EXPLORE_CUSTOM_DATE: 'EXPLORE_CUSTOM_DATE',
  ACCESS_ASO_TRANSLATION: 'ACCESS_ASO_TRANSLATION',
  ACCESS_ASO_REPORT_EXTENDED: 'ACCESS_ASO_REPORT_EXTENDED',
  ACCESS_MARKET_INTELLIGENCE_APP_ANALYSIS: 'ACCESS_MARKET_INTELLIGENCE_APP_ANALYSIS',
  OPTIONS_MARKET_INTELLIGENCE: 'OPTIONS_MARKET_INTELLIGENCE',
  ACCESS_AC_INTELLIGENCE: 'ACCESS_AC_INTELLIGENCE',
  ACCESS_KEYWORD_POSITION_MAP: 'ACCESS_KEYWORD_POSITION_MAP',
  LIMIT_STORE_MANAGEMENT_EXPORT: 'LIMIT_STORE_MANAGEMENT_EXPORT',
  LIMITED_APPS: 'LIMITED_APPS',
  LIMITED_CATEGORY: 'LIMITED_CATEGORY',
  LIMITED_COUNTRY: 'LIMITED_COUNTRY',
  LIMITED_ITEMS: 'LIMITED_ITEMS',
  LIMITED_KEYWORDS: 'LIMITED_KEYWORDS',
  ADD_CHART_ANNOTATION: 'ADD_CHART_ANNOTATION',
  ACCESS_CREATIVE_MONITORING: 'ACCESS_CREATIVE_MONITORING',
})

export {
  FEATURES,
  PRODUCT_FAMILY,
  PRODUCTS,
}
